import React from 'react';

interface TeamItem {
  id: string;
  name: string;
  logo?: string | null;
  country?: string | null;
  city?: string | null;
  venue?: string | null;
  website?: string | null;
  social_media?: Record<string, string> | null;
  date_established?: string | null;
}

interface Props {
  teams: TeamItem[];
  loading?: boolean;
}

const MyTeamsSection: React.FC<Props> = ({ teams, loading = false }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-5">
        <h2 className="text-lg font-semibold text-gray-900 mb-3">My Teams</h2>
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  if (!teams || teams.length === 0) return null;

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-5">
      <h2 className="text-lg font-semibold text-gray-900 mb-3">My Teams</h2>
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm">
          <thead>
            <tr className="text-left text-gray-500">
              <th className="py-2 pr-4">Logo</th>
              <th className="py-2 pr-4">Team</th>
              <th className="py-2 pr-4">Country</th>
              <th className="py-2 pr-4">City</th>
              <th className="py-2 pr-4">Venue</th>
              <th className="py-2 pr-4">Website</th>
              <th className="py-2 pr-4">Established</th>
              <th className="py-2 pr-4">Social</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {teams.map((t) => (
              <tr key={t.id} className="align-top">
                <td className="py-2 pr-4">
                  {t.logo ? (
                    <img src={t.logo} alt={t.name} className="w-8 h-8 rounded object-cover" />
                  ) : (
                    <div className="w-8 h-8 rounded bg-gray-100 flex items-center justify-center">⚽</div>
                  )}
                </td>
                <td className="py-2 pr-4 text-gray-900 font-medium">{t.name}</td>
                <td className="py-2 pr-4">{t.country || '—'}</td>
                <td className="py-2 pr-4">{t.city || '—'}</td>
                <td className="py-2 pr-4">{t.venue || '—'}</td>
                <td className="py-2 pr-4">{t.website ? (<a href={t.website} target="_blank" rel="noreferrer" className="text-blue-600 hover:underline">{t.website}</a>) : '—'}</td>
                <td className="py-2 pr-4">{t.date_established ? new Date(t.date_established).toLocaleDateString() : '—'}</td>
                <td className="py-2 pr-4">
                  {(() => {
                    const entries = Object.entries((t.social_media as Record<string, any>) || {})
                      .filter(([_, v]) => typeof v === 'string' && v.trim().length > 0 && /^(https?:)?\/\//.test(v.trim()));
                    if (entries.length === 0) return <span className="text-gray-400">—</span>;
                    return (
                      <div className="flex flex-wrap gap-2">
                        {entries.map(([k, v]) => (
                          <a key={k} href={String(v)} target="_blank" rel="noreferrer" className="px-2 py-0.5 rounded-full bg-gray-100 text-blue-700 border border-gray-200 hover:underline text-[11px]">{k}</a>
                        ))}
                      </div>
                    );
                  })()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MyTeamsSection;


